export default __webpack_public_path__ + "static/digitize-dbc5781cb5777c1b7bfd0796e436b675.webp";